import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import navigation from 'menu-items';

/**
 * Recursively search all menu items for a matching url.
 * Returns an array of breadcrumb segments: [group, ...collapses, item]
 */
function findCrumbs(items, pathname, ancestors = []) {
  for (const node of items) {
    if (node.type === 'item') {
      if (pathname === node.url || pathname.startsWith(node.url + '/')) {
        return [...ancestors, node];
      }
    } else if (node.children?.length) {
      const found = findCrumbs(node.children, pathname, [...ancestors, node]);
      if (found) return found;
    }
  }
  return null;
}

export default function Breadcrumbs() {
  const { pathname } = useLocation();

  const crumbs = useMemo(() => findCrumbs(navigation.items, pathname), [pathname]);

  if (!crumbs) return null;

  // Last crumb is the active page item; everything before it is the trail
  const trail = crumbs.slice(0, -1);
  const active = crumbs[crumbs.length - 1];

  if (active?.breadcrumbs === false) return null;

  const items = [
    { title: <Link to="/dashboard"><HomeOutlined /></Link> },
    ...trail
      // skip 'group' nodes that have no url — show only named collapse parents
      .filter((n) => n.type !== 'group')
      .map((n) => ({ title: <span style={{ color: '#8c8c8c' }}>{n.title}</span> })),
    { title: <Typography.Text strong>{active.title}</Typography.Text> },
  ];

  return (
    <div style={{ marginBottom: 16 }}>
      <Breadcrumb items={items} />
    </div>
  );
}
